// Librairies importées.
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';

// Stores.
import { MessageStoreMethods } from '@/store/MessageStore';

// Modèles.
import { Message } from '@/shared/models/Message.model';

// Énumérations.
import { MessageLevel } from '@/shared/enums/MessageLevel.enum';

@Component
export default class AffichageMessages extends Vue {
    /**
     * Récupération des messages à afficher.
     */
    @Getter(MessageStoreMethods.GET_MESSAGES)
    public messages: Message[];

    /**
     * Suppression des messages quand on clique sur la croix.
     */
    @Mutation(MessageStoreMethods.CLEAR_MESSAGES)
    private nettoyerMessages: () => void;

    /**
     * Dernier message ayant été retourné.
     */
    public message: Message | null = null;

    /**
     * Couleurs des messages en fonction de leur niveau.
     */
    private readonly couleursMessage = {
        [MessageLevel.Success]: 'success',
        [MessageLevel.Error]: 'error',
        [MessageLevel.Info]: 'info',
        [MessageLevel.Warning]: 'warning',
    };

    /**
     * Détermine s'il faut afficher un message.
     */
    public get afficherSnackbar(): boolean {
        return this.message !== null && this.message.text !== undefined;
    }

    /**
     * Cache le message.
     */
    public set afficherSnackbar(value: boolean) {
        this.message = null;
    }

    /**
     * Récupération de la couleur de la snackbar en fonction du niveau de message.
     */
    public get couleur() {
        return this.message ? this.couleursMessage[MessageLevel[this.message.messageLevel]] : '';
    }

    /**
     * Vérifie s'il y a des messages en attente.
     */
    @Watch('messages', { immediate: false, deep: true })
    public loadMessages() {
        // On affiche les derniers messages quand ils arrivent.
        if (this.messages && this.messages.length) {
            this.message = this.messages[this.messages.length - 1];
            this.nettoyerMessages();
        }
    }
}
